export const QUERY_PARAMS_DIVIDER = '&';
//# sourceMappingURL=url.js.map